import { render, staticRenderFns } from "./PopupCloseButton.vue?vue&type=template&id=28320160&scoped=true&"
import script from "./PopupCloseButton.vue?vue&type=script&lang=ts&"
export * from "./PopupCloseButton.vue?vue&type=script&lang=ts&"
import style0 from "./PopupCloseButton.vue?vue&type=style&index=0&id=28320160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28320160",
  null
  
)

export default component.exports